/**
 * Desabilita console.log em produção para evitar vazamento de informações sensíveis
 * Mantém apenas console.error para erros críticos
 */

export const disableConsoleInProduction = (): void => {
  if (import.meta.env.PROD) {
    // Salva referências originais para uso interno se necessário
    const originalLog = console.log;
    const originalWarn = console.warn;
    const originalInfo = console.info;
    const originalDebug = console.debug;

    // Desabilita logs em produção
    console.log = () => {};
    console.warn = () => {};
    console.info = () => {};
    console.debug = () => {};

    // Mantém console.error para erros críticos, mas sanitiza dados sensíveis
    const originalError = console.error;
    console.error = (...args: unknown[]) => {
      // Sanitiza argumentos para remover dados sensíveis
      const sanitizedArgs = args.map(arg => {
        if (typeof arg === 'string') {
          return arg
            .replace(/token[:\s=]+[a-zA-Z0-9._-]+/gi, 'token: [REDACTED]')
            .replace(/password[:\s=]+[^\s]+/gi, 'password: [REDACTED]')
            .replace(/secret[:\s=]+[^\s]+/gi, 'secret: [REDACTED]')
            .replace(/api[_-]?key[:\s=]+[^\s]+/gi, 'api_key: [REDACTED]')
            .replace(/authorization[:\s=]+[^\s]+/gi, 'authorization: [REDACTED]')
            .replace(/bearer\s+[a-zA-Z0-9._-]+/gi, 'bearer [REDACTED]');
        }
        return arg;
      });

      originalError.apply(console, sanitizedArgs);
    };

    // Em desenvolvimento, imprime aviso
    if (import.meta.env.DEV) {
      originalLog('🔒 Console logs habilitados em desenvolvimento');
    }
  } else {
    console.log('🔓 Console logs habilitados em desenvolvimento');
  }
};

export default disableConsoleInProduction;
